import { render, staticRenderFns } from "./ChangePwd.vue?vue&type=template&id=6172d37d&scoped=true"
import script from "./ChangePwd.vue?vue&type=script&lang=js"
export * from "./ChangePwd.vue?vue&type=script&lang=js"
import style0 from "./ChangePwd.vue?vue&type=style&index=0&id=6172d37d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6172d37d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6172d37d')) {
      api.createRecord('6172d37d', component.options)
    } else {
      api.reload('6172d37d', component.options)
    }
    module.hot.accept("./ChangePwd.vue?vue&type=template&id=6172d37d&scoped=true", function () {
      api.rerender('6172d37d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/ChangePwd.vue"
export default component.exports